const hotDogElement = () => document.querySelector('.hotdog');
const touchNavigation = () => document.querySelectorAll('.touch-navigation');
const body = () => document.querySelector('body');

const toggleResponsiveMainNavigation = function (event) {
  if (event) {
    event.preventDefault();
  }
  if (hotDogElement()) {
    hotDogElement().classList.toggle('active');
  }
  touchNavigation().forEach(el => {
    el.classList.toggle('open');
  });
  body().classList.toggle('site-navigation-open');
};

const onClickNavigation = (event) => {

  let href = '';
  let promobox = event.target.closest('.sub-navigation-promobox');
  if (!promobox) {
    let li = event.target.closest('li');
    if (!li) {
      return;
    }
    href = li.querySelector('a').getAttribute('href');
  } else {
    href = event.getAttribute('href');
  }

  if (event) {
    event.preventDefault();
  }

  // Navigation: prevent click on empty links
  if ((!href) || (href === '#')) {
    return;
  }

  // if clicking on # links from the current page, close the response navigation
  if (href && (href.startsWith(`${document.location.pathname}#`) || href === document.location.toString())) {
    toggleResponsiveMainNavigation();
  }

  if (window.Turbo) {
    console.debug(`Navigating to ${href}`);
    Turbo.visit(href);
  } else {
    window.location = href;
  }
};

const activeMenuItems = () => document.querySelectorAll('#navigation-main ul li.active');

const removeActive = () => {
  activeMenuItems().forEach((el) => el.classList.remove('active'));
};

const setCurrentLinkInNavi = (el, exactMatchForURL) => {
  let maxMarkedElements = 1;
  let markedElements = 0;

  el.querySelectorAll('a[href]').forEach((a) => {
    let href = a.getAttribute('href');
    let pathname = null;
    try {
      pathname = new URL(href).pathname;
    } catch (e) {
      if (e.message.match(/Invalid URL/)) {
        // ignore this error
        if (href.startsWith('/')) {
          try {
            pathname = new URL(window.location.origin + href).pathname;
          } catch (e) {
            console.error(e);
            return;
          }
        } else {
          return;
        }
      }
    }

    let documentPathname = window.location.pathname;
    let urlsAreMatching = (exactMatchForURL) ? documentPathname === pathname : documentPathname.startsWith(pathname + '/');

    if (urlsAreMatching) {
      if (markedElements < maxMarkedElements) {
        markedElements++;
        el.classList.add('active');
        ['li.sub-navigation-with-icon', 'li.has-sub-navigation'].forEach(sel => {
          if (a.closest(sel)) {
            a.closest(sel).classList.add('active');
          }
        });
      }
    }
  });
  return markedElements;
};

const removeActiveAndSetCurrentLinkInNavi = () => {
  removeActive();
  ['#navigation-main > ul li:not(.has-sub-navigation):not(.sub-navigation-border-top)', '#navigation-main > ul li.has-sub-navigation'].forEach((selector) => {
    // find current url in menu
    let linkingDone = false;
    let listElements = document
      .querySelectorAll(selector);
    for (let listElement of listElements) {
      if (setCurrentLinkInNavi(listElement, true) > 0) {
        linkingDone = true;
        break;
      }
    }

    if (linkingDone) {
      return;
    }

    for (let listElement of listElements) {
      if (setCurrentLinkInNavi(listElement, false) > 0) {
        break;
      }
    }
  });
};

export default () => {
  document.querySelectorAll('#header a[href]').forEach((el) => {
    el.removeEventListener('click', onClickNavigation);
    el.addEventListener('click', onClickNavigation);
  });

  document.querySelectorAll('.touch-navigation > ul > li').forEach(el => el.addEventListener('click', (ev) => {
    el.classList.toggle('expanded');
  }));

  window.toggleResponsiveMainNavigation = toggleResponsiveMainNavigation;

  if (hotDogElement()) {
    hotDogElement().classList.remove('active');
  }

  touchNavigation().forEach(el => {
    el.classList.remove('open');
  });

  body().classList.remove('site-navigation-open');
  removeActiveAndSetCurrentLinkInNavi();

  //Todo: Replace headroom with easy function to check if on top
  function setHeaderBackground() {
    const header = document.querySelector('.header');
    const headerClasses = header.className.split(' ').filter(function (singleClass) {
      return !singleClass.endsWith('-background');
    });

    if (body().classList.contains('headroom-top')) {
      const background = header.getAttribute('data-background');
      const backgroundTheme = header.getAttribute('data-background-theme');

      headerClasses.push(background + '-background');
      headerClasses.push(backgroundTheme + '-background');
    }

    header.className = headerClasses.join(' ');
    return true;
  }

  if (document.querySelector('.header')) {
    window.addEventListener('scroll', setHeaderBackground);
    setInterval(setHeaderBackground, 250);
  }

  /*
  // Contact Button hover
  function checkContactButtonHover() {
    const button = document.querySelector('.navigation-main-contact');
    const box = document.querySelector('.navigation-main-contact-button-wrapper');

    if (!button.classList.contains('navigation-main-contact-button-hover') && !box.classList.contains('navigation-main-contact-button-hover')) {
      box.classList.remove('navigation-main-contact-button-wrapper-hover');
    }
  }

  if (document.querySelector('.navigation-main-contact') && document.querySelector('.navigation-main-contact-button-box')) {
    const button = document.querySelector('.navigation-main-contact');
    const box = document.querySelector('.navigation-main-contact-button-wrapper');
    const innerBox = document.querySelector('.navigation-main-contact-button-box');
    const container = button.closest('.section-container');

    const boxWidth = innerBox.offsetWidth;
    const buttonRight = button.getBoundingClientRect().right;
    const buttonWidth = button.offsetWidth;
    const containerRight = container.getBoundingClientRect().right;
    box.style.right = `${containerRight - buttonRight + buttonWidth/2 - boxWidth/2}px`;

    button.addEventListener('mouseover', () => {
      button.classList.add('navigation-main-contact-button-hover');
      box.classList.add('navigation-main-contact-button-wrapper-hover');
    });
    box.addEventListener('mouseover', () => {
      box.classList.add('navigation-main-contact-button-hover');
      box.classList.add('navigation-main-contact-button-wrapper-hover');
    });
    button.addEventListener('mouseout', () => {
      button.classList.remove('navigation-main-contact-button-hover');
      checkContactButtonHover();
    });
    box.addEventListener('mouseout', () => {
      box.classList.remove('navigation-main-contact-button-hover');
      checkContactButtonHover();
    });
  }*/
};
